import React, { Suspense } from "react"
import LoadingIndicator from "./utils/LoadingIndicator";
import { Routes, Route } from "react-router-dom";
import { routes } from "./routes/Routes";
import './App.css';


function App() {
  return (
    <div className="App">
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          {routes.map((route, key) => {
            return route ? <Route key={key} {...route} /> : null;
          })}
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
